import { Form, Input, message } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import React, { FC, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AuthingModal } from "@/components/AuthingModal";
import Axios from "axios";
import { checkPassword } from "@/api/checkPassword";
import { checkPhoneCode } from "@/api/checkPhoneCode";
import axios from "axios";
import styles from "./styles.module.less";
import { User } from "authing-js-sdk";
import { SendPhoneCode } from "@/components/SendPhoneCode";

interface LogOffProps {
  visible: boolean;
  onLogOffOK?: () => void;
  onLogOffCancel?: () => void;
}
interface AppList {
  list: Array<any>;
  totalCount: number;
}
export const LogOff: FC<LogOffProps> = ({
  visible,
  onLogOffOK,
  onLogOffCancel,
}) => {
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [verifyCode, setVerifyCode] = useState("");
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [apps, setApps] = useState<AppList | undefined>();
  const [userPools, setUserPools] = useState<AppList | undefined>();
  const isMessager =
    window.__config__.userPoolId === window.__config__.rootUserPoolId;
  const userInfo: User = window.__user__ as User;
  // 是否为三方登录 true 为不是 false 为是
  const status = userInfo.phone || userInfo.password;
  useEffect(() => {
    (async () => {
      //userpools
      if (isMessager) {
        const { data: userPools } = await Axios.get(
          "api/v2/userpools?page=1&limit=100",
          {
            headers: {
              Authorization: localStorage.getItem("_authing_token") || "",
            },
          }
        );
        setUserPools(userPools);
      }
      // applications
      const { data: apps } = await Axios.get(
        `api/v2/users/me/applications/allowed`,
        {
          headers: {
            Authorization: localStorage.getItem("_authing_token") || "",
          },
        }
      );
      setApps(apps);
    })();
    // eslint-disable-next-line
  }, []);
  return (
    <AuthingModal
      title={"账号注销"}
      visible={visible}
      onOk={async () => {
        !status && setLoading(true);
        !status
          ? await axios
              .delete("api/v2/users/delete", {
                headers: {
                  Authorization: localStorage.getItem("_authing_token") || "",
                },
              })
              .then((data: any) => {
                if (data?.code === 200) {
                  setLoading(false);
                  form.resetFields();
                  setPassword("");
                  onLogOffOK && onLogOffOK();
                  message.success("注销成功");
                  localStorage.clear();
                  setTimeout(() => {
                    window.location.href = "/";
                  }, 500);
                } else {
                  setLoading(false);
                  message.error(data?.message);
                }
              })
              .catch((error) => {
                setLoading(false);
                console.log(error);
              })
          : form.submit();
      }}
      okButtonProps={{
        disabled: status && !(password.length || verifyCode.length),
      }}
      onCancel={() => {
        form.resetFields();
        setPassword("");
        onLogOffCancel && onLogOffCancel();
      }}
      confirmLoading={loading}
    >
      {isMessager ? (
        <>
          <p className={styles.logOffTips}>
            <CloseCircleOutlined
              style={{ color: "#E63333", marginRight: "6px" }}
            />
            注销后您将无法管理以下用户池:
          </p>
          <div className={styles.applist}>
            {userPools && userPools.list.length > 0
              ? userPools.list.map((item, index) => {
                  if (index === userPools.list.length - 1) {
                    return item.name + `，共 ${userPools.totalCount} 个用户池`;
                  } else {
                    return item.name + "、";
                  }
                })
              : "暂未注册用户池"}
          </div>
        </>
      ) : (
        <>
          <p className={styles.logOffTips}>
            <CloseCircleOutlined
              style={{ color: "#E63333", marginRight: "6px" }}
            />
            注销后您将无法登录以下应用:
          </p>
          <div className={styles.applist}>
            {apps
              ? apps.list.map((item, index) => {
                  if (index === apps.list.length - 1) {
                    return item.name + `，共 ${apps.totalCount} 个应用`;
                  } else {
                    return item.name + "、";
                  }
                })
              : "暂未注册应用"}
          </div>
        </>
      )}
      {userInfo.phone && (
        <>
          <div className={styles.sendPhone}>
            将发送验证码至绑定手机&nbsp;
            {String(userInfo.phone).replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")}
          </div>
        </>
      )}
      {/*判断是否是三方登录 */}
      {status ? (
        <Form
          form={form}
          onFinish={async (values: any) => {
            setLoading(true);
            if (userInfo.phone) {
              // 使用手机验证码注销
              await checkPhoneCode(userInfo.phone, values.verifyCode)
                .then(async (user) => {
                  await axios
                    .delete("api/v2/users/delete", {
                      headers: {
                        Authorization:
                          localStorage.getItem("_authing_token") || "",
                      },
                    })
                    .then((data: any) => {
                      if (data?.code === 200) {
                        setLoading(false);
                        form.resetFields();
                        setPassword("");
                        onLogOffOK && onLogOffOK();
                        message.success("注销成功");
                        localStorage.clear();
                        setTimeout(() => {
                          window.location.href = "/";
                        }, 500);
                      } else {
                        setLoading(false);
                        message.error(data?.message);
                      }
                    })
                    .catch((error) => {
                      setLoading(false);
                      console.log(error);
                    });
                })
                .catch((error) => {
                  setLoading(false);
                  message.error(error[0].message.message);
                });
            } else {
              // 使用密码验证注销
              await checkPassword(values)
                .then(async ({ code, message: info }) => {
                  if (code === 200) {
                    await axios
                      .delete("api/v2/users/delete", {
                        headers: {
                          Authorization:
                            localStorage.getItem("_authing_token") || "",
                        },
                      })
                      .then((data: any) => {
                        if (data?.code === 200) {
                          setLoading(false);

                          form.resetFields();
                          setPassword("");
                          onLogOffOK && onLogOffOK();
                          message.success("注销成功");
                          localStorage.clear();
                          setTimeout(() => {
                            window.location.href = "/";
                          }, 500);
                        } else {
                          setLoading(false);
                          message.error(data?.message);
                        }
                      })
                      .catch((error) => {
                        setLoading(false);
                        console.log(error);
                      });
                  } else {
                    setLoading(false);
                    message.error(info);
                  }
                })
                .catch((error) => {
                  setLoading(false);
                  message.error(error);
                });
            }
          }}
        >
          {userInfo.phone ? (
            <Form.Item
              name="verifyCode"
              rules={[{ required: true, message: t("login.noEmpty") }]}
            >
              <Input
                placeholder="请输入验证码"
                value={verifyCode}
                onChange={(e) => setVerifyCode(e.target.value)}
                addonAfter={<SendPhoneCode phone={userInfo.phone as string} />}
              />
            </Form.Item>
          ) : (
            <Form.Item
              name="password"
              rules={[{ required: true, message: t("login.noEmpty") }]}
            >
              <Input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                placeholder={"请输入当前密码"}
              />
            </Form.Item>
          )}
        </Form>
      ) : null}
    </AuthingModal>
  );
};
